import { useAuth } from './context/AuthContext';
import Header from './Components/Header';
import { Navigate, Outlet } from 'react-router';
import useProfile from './customHooks/useProfile';
import { useState, useEffect } from "react";

const ProtectedRoute = () => {
    const { email, userVerified } = useAuth(); // Renamed userVarified to userVerified for consistency
    const { checkProfileStatus } = useProfile();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validate = async () => {
            if (!email) return setLoading(false);

            await checkProfileStatus();
            setLoading(false);
        };
        validate();
    }, [email]);

    if (loading) return <div>Loading...</div>;

    if (!email) return <Navigate to="/login" />;

    if (userVerified !== "VERIFIED") {
        if (userVerified === "PENDING") return <Navigate to="/profileform" />;
        if (userVerified === "IN_REVIEW") return <Navigate to="/profilepending" />;
    }

    return (
        <>
            <Header />
            <Outlet />
        </>
    );
};

export default ProtectedRoute;